import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseCreateDto } from '../base/baseCreate.dto'

@ArgsType()
export class CreateUserDto extends BaseCreateDto<CreateUserDto> {
  @Field()
  emailAddress!: string

  @Field(type => Int)
  consentMethod!: number

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true })
  image?: string

  @Field({ nullable: true })
  kindleEmail?: string

  @Field({ nullable: true })
  verifiedKindleEmail?: boolean

  @Field({ nullable: true })
  amazonProfileLink?: string

  // The properties below aren't exposed via the graphql interface
  @Field(t => [Int], { nullable: true })
  canActAs?: number[]

  @Field({ nullable: true })
  lockRoles?: boolean

  @Field({ nullable: true })
  notificationRegistrationToken?: string

  @Field({ nullable: true })
  completedTours?: string

  @Field({ nullable: true })
  authorRole?: string

  @Field({ nullable: true })
  ipAddress?: string
}
